import { fromJS } from 'immutable';
import CUSTOMER_LOYALTY_CONSTANTS from '../constants/CustomerLoyalty.constants';

const initialState = fromJS({
  loyaltyOrderItemPoints: {},
});

// eslint-disable-next-line complexity
const CustomerLoyaltyReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_LOYALTY_CONSTANTS.SET_LOYALTY_ORDER_ITEM_POINTS:
      return state.set('loyaltyOrderItemPoints', action.payload);
    default:
      // TODO: currently when initial state is hydrated on browser, List is getting converted to an JS Array
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

export default CustomerLoyaltyReducer;
